<template>
  <v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          :items="deposits || []"
          :headers="depositsTableHeaders"
          item-key="transaction_hash_hex"
        >
          <template slot="items" slot-scope="props">
            <td>{{ paymentsForUserWithToken ? props.item.email : props.item.user_id }}</td>
            <td>{{ props.item.ts_utc_secs | formatDateTS("DD MMM YYYY HH:mm") }}</td>
            <td>
              {{
                $options.filters.toETHFormat(props.item.value_wei_str)
                  | roundMarketsFractionalAccountValue
              }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<style scoped>
>>> .v-card {
  box-shadow: none;
}
>>> .theme--dark .v-card__text {
  background: #212121 !important;
}
</style>

<script>
import axios from "axios";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
export default {
  name: "UserDeposits",
  props: {
    paymentId: {
      type: Number,
      default: 0
    },
    paymentCurrency: {
      type: String,
      default: null
    },
    paymentsForUserWithToken: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      deposits: null
    };
  },
  computed: {
    depositsTableHeaders() {
      if (this.paymentsForUserWithToken) {
        return [
          { text: "Email", value: "email" },
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc_secs"
          },
          {
            text:
              "Value (" +
              (this.paymentCurrency ? this.paymentCurrency : "") +
              ")",
            value: "value_wei_str"
          }
        ];
      }
      return [
        { text: "User id", value: "user_id" },
        {
          text: `Date (${moment()
            .tz(moment.tz.guess())
            .format("z")})`,
          value: "ts_utc_secs"
        },
        {
          text:
            "Value (" +
            (this.paymentCurrency ? this.paymentCurrency : "") +
            ")",
          value: "value_wei_str"
        }
      ];
    }
  },
  mounted: async function() {
    axios
      .get(
        "/api/v1/whitelabel/userDeposits/" +
          this.paymentId +
          "/" +
          this.paymentCurrency
      )
      .then(res => {
        this.deposits = res.data;
      });
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/whitelabel/UserDeposits.vue